// extracted by mini-css-extract-plugin
export default {"_":"GearIcon____E9vb8","closeButton":"GearIcon_closeButton__bZhkM","open":"GearIcon_open__ZdGXg"};